import { render, staticRenderFns } from "./block-main.vue?vue&type=template&id=3d18063d&scoped=true"
import script from "./block-main.vue?vue&type=script&lang=js"
export * from "./block-main.vue?vue&type=script&lang=js"
import style0 from "./block-main.vue?vue&type=style&index=0&id=3d18063d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d18063d",
  null
  
)

export default component.exports